import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-233fedbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "cont-nav" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  border: "1",
  bordercolor: "#ccc"
}
const _hoisted_6 = {
  border: "1",
  ref: "table2"
}
const _hoisted_7 = ["onMouseenter"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_ctx.noAllData)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: 'zdsx' + i,
              class: _normalizeClass({ active: tag.value === _ctx.activeTagVal }),
              onClick: ($event: any) => (_ctx.checkTag(tag))
            }, _toDisplayString(tag.label), 11, _hoisted_3))
          }), 128))
        ]),
        _createVNode(_component_a_spin, {
          tip: "加载中...",
          spinning: _ctx.spinning
        }, {
          default: _withCtx(() => [
            ((_ctx.data || []).length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("table", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: 'zdsxtr' + i
                        }, [
                          _createElementVNode("th", null, _toDisplayString(item.title), 1)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("table", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: 'zdsxtr2' + i
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (td, idx) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: 'zdsxttd' +idx
                            }, [
                              (item.slots && item.slots.customRender === 'peopleCount')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    style: _normalizeStyle({'width' : _ctx.table2TdWidth})
                                  }, _toDisplayString(td[item.key] >= 100000000
                      ? (td[item.key] / 100000000).toFixed(2) + "亿"
                      : td[item.key] >= 10000
                      ? (td[item.key] / 10000).toFixed(2) + "万"
                      : td[item.key] && String(td[item.key]) !== "0"
                      ? td[item.key]
                      : "—"), 5))
                                : (
                    item.slots && item.slots.customRender === 'increase'
                  )
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass([
                    td[item.key] > 0 ? 'red' : td[item.key] < 0 ? 'green' : ''
                  ]),
                                      style: _normalizeStyle({'width' : _ctx.table2TdWidth})
                                    }, _toDisplayString(td[item.key] > 0 ? "+" : "") + _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                      ? (td[item.key] || 0).toFixed(2) + "%"
                      : "—"), 7))
                                  : (
                    item.slots && item.slots.customRender === 'nocolorincrease'
                  )
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        style: _normalizeStyle({'width' : _ctx.table2TdWidth})
                                      }, _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                      ? (td[item.key] || 0).toFixed(2) + "%"
                      : "—"), 5))
                                    : (item.slots && item.slots.customRender === 'ellipsis')
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 3,
                                          style: _normalizeStyle({'width' : _ctx.table2TdWidth})
                                        }, [
                                          _createVNode(_component_a_tooltip, {
                                            title: _ctx.tooltip[(item.key+idx)] ? td[item.key] : ''
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", {
                                                class: "hover-tit",
                                                onMouseenter: ($event: any) => (_ctx.handleEnter($event,(item.key+idx)))
                                              }, _toDisplayString(td[item.key] ||  "—"), 41, _hoisted_7)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"])
                                        ], 4))
                                      : (
                    item.slots && item.slots.customRender === 'decimal'
                  )
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 4,
                                            style: _normalizeStyle({'width' : _ctx.table2TdWidth})
                                          }, _toDisplayString(td[item.key] && String(td[item.key]) !== "0"
                      ? (td[item.key] || 0).toFixed(2)
                      : "—"), 5))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 5,
                                            style: _normalizeStyle({'width' : _ctx.table2TdWidth})
                                          }, _toDisplayString(td[item.key] || "—"), 5))
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ], 512)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_8, [
                  _createVNode(_component_Nodata, { nodatadesc: _ctx.noDataTitle }, null, 8, ["nodatadesc"])
                ]))
          ]),
          _: 1
        }, 8, ["spinning"])
      ]))
    : (_openBlock(), _createElementBlock("section", _hoisted_9, [
        _createVNode(_component_Nodata, {
          customdesc: !_ctx.noAllData?'该股暂无重大事项':null,
          nodatadesc: _ctx.noDataTitle
        }, null, 8, ["customdesc", "nodatadesc"])
      ]))
}